import Loader from '@bugbug/core/components/Loader';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  gap: 16px;
  width: 245px;
  min-height: 220px;
  border: 2px solid ${(props) => props.theme.colors.border.semi};
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 4px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RowTitle = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: ${(props) => props.theme.colors.text.secondary};
  font-weight: ${(props) => props.theme.fontWeight.regular};
  margin: 0;
`;

export const RowValue = styled(RowTitle)`
  color: ${(props) => props.theme.colors.text.normal};
`;

export const DiscountedValue = styled.span`
  color: ${(props) => props.theme.colors.text.emptyState};
  text-decoration: line-through;
  margin-right: 5px;
`;

export const TotalTitle = styled(RowTitle)`
  font-weight: ${(props) => props.theme.fontWeight.medium};
  color: ${(props) => props.theme.colors.text.normal};
`;

export const TotalValue = styled(RowTitle)`
  font-weight: ${(props) => props.theme.fontWeight.bold};
  color: ${(props) => props.theme.colors.text.normal};
  font-size: 14px;
`;

export const PromoTitle = styled(RowTitle)`
  font-weight: ${(props) => props.theme.fontWeight.medium};
  color: ${(props) => props.theme.colors.status.success};
`;

export const PromoValue = styled(RowValue)`
  color: ${(props) => props.theme.colors.status.success};
  font-weight: ${(props) => props.theme.fontWeight.medium};
  text-transform: uppercase;
`;

export const Error = styled.span`
  font-size: 12px;
  line-height: 14px;
  color: ${(props) => props.theme.colors.status.failure};
  margin: 0;
  margin-right: 4px;
`;

export const Title = styled.p`
  font-size: 14px;
  line-height: 1.2;
  font-weight: ${(props) => props.theme.fontWeight.bold};
  margin: 0;
`;

export const Separator = styled.div`
  height: 2px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.border.semi};
`;

export const PriceLoader = styled(Loader)`
  margin: 8px auto;
`;

export const PaymentInfo = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: ${(props) => props.theme.colors.text.lighter};
  margin: 0;
  padding: 4px 0;
`;
